import _regeneratorRuntime from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var app, Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = _ref.app, Vue = _ref.Vue;
            Sentry.init({
              dsn: 'https://96cfbd31eab843c09dfda7d22d0c0d44@sentry.io/4479811',
              integrations: [new Integrations.Vue({
                Vue: Vue,
                attachProps: true,
                logErrors: true
              })]
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();